import { ActionDocumentType } from './action-document-type.enum';

export enum EngagementDocumentSource {
    AdminUpload = 0,
    Template = 1,
    BuyerUpload = 2,
    Questionnaire  = 3,
    BrokerUpload = 4,
    DataTableFiles = 5,
}

export const EngagementDocumentSourceOptions = {
    [EngagementDocumentSource.AdminUpload]: 'Admin Upload',
    [EngagementDocumentSource.Template]: 'Template',
    [EngagementDocumentSource.BuyerUpload]: 'Buyer Upload',
    [EngagementDocumentSource.Questionnaire]: 'Questionnaire',
    [EngagementDocumentSource.BrokerUpload]: 'Advisor Upload',
    [EngagementDocumentSource.DataTableFiles]: 'Data Table Files',
};

export const EngagementDocumentSourceOptionsMapping = [
    {
        value: EngagementDocumentSource.AdminUpload,
        label: EngagementDocumentSourceOptions[
            EngagementDocumentSource.AdminUpload
        ],
        documentTypes: [
            ActionDocumentType.DocumentWithFeedback,
            ActionDocumentType.Downloadable,
            ActionDocumentType.Readonly,
        ],
    },
    {
        value: EngagementDocumentSource.Template,
        label: EngagementDocumentSourceOptions[
            EngagementDocumentSource.Template
        ],
        documentTypes: [ActionDocumentType.ForSign],
    },
    {
        value: EngagementDocumentSource.BuyerUpload,
        label: EngagementDocumentSourceOptions[
            EngagementDocumentSource.BuyerUpload
        ],
        documentTypes: [ActionDocumentType.IdNda],
    },
    {
        value: EngagementDocumentSource.Questionnaire,
        label: EngagementDocumentSourceOptions[
            EngagementDocumentSource.Questionnaire
        ],
        documentTypes: [],
    },
];
